<template>
  <div class="container">
    <van-nav-bar title="通讯录" left-text="" 
      left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <van-search maxlength='100' v-model="keyword" @input="searchList" shape="round" placeholder="请输入项目名称、姓名、手机号、岗位" />

    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
      @load="onLoad"
    >
      <div class="list-box">
        <div class="list" :key="index" v-for="(item,index) in projectList">
          <div class="list-left">
            <div class="bold mg10">{{item.communityName}}</div>
            <div class="mg10">{{item.nikeName}}</div>
            <div class=""> <span class="name">{{item.roleName}}</span><span class="tel">{{item.mobile}}</span></div>
          </div>
          <div class="list-right">
            <a class="tel" :href="'tel:'+item.mobile">
              <img src="../assets/img/phone.png" alt="">
            </a>
          </div>
        </div>
        
      </div>
    </van-list>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Loading,Search,List} from 'vant';
  export default {
    data() {
      return {
        keyword: '',
        allCount:0,
        pageIndex:1,
        pageSize:10,
        loading: false,
        finished:false,
        projectList:[],
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Search.name]:Search,
      [List.name]:List,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"})
      },
      onLoad(){
        // 异步更新数据
        setTimeout(()=>{
          this.pageIndex++;
          this.getMoreList();
        },500)
      },
      searchList(){
        this.pageIndex = 1;
        var regx = /^[0-9\u4e00-\u9fa5]+$/;
        if(!regx.test(this.keyword)){
          this.keyword = '';
          // Toast('只能输入汉字或数字');
        }
        this.getProjectList();
      },
      getProjectList() {
        axios.post("/center/addressbooklist",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            keyword: this.keyword,
          }
        }).then((res)=>{
          this.projectList = res.data.list;
          this.allCount = res.data.total;
        })
      },
      getMoreList() {
        axios.post("/center/addressbooklist",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            keyword: this.keyword,
          }
        }).then((res)=>{
          this.projectList = this.projectList.concat(res.data.list);
          this.allCount = res.data.total;
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.pageIndex * this.pageSize >= this.allCount) {
            this.finished = true;
          }
        })
      },
      onClickLeft() {
        this.$router.go(-1);
      },
      onClickRight() {
        
      },
    },
    computed:{
    },
    created () {
      this.getProjectList();
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
  }
  .list-box{
    width: 100%;
    color: #373737;
    .list{
      font-size: 14px;
      width: 100%;
      background: #fff;
      margin: 12px 0;
      padding: 12px;
      display: flex;
      justify-content: space-between;
      .list-left{
        width: 80%;
        .name{
          min-width: 140px;
          margin-right: 10px;
          display: inline-block;
        }
      }
      .list-right{
        text-align: right;
        img{
          width: 56px;
          margin-top: 10px;
        }
      }
    }
    .mg10{margin-bottom: 10px;}
    .bold{font-weight: bold;}
  }
</style>
